import React, { useState, useEffect } from 'react';
import "./AllEvents.css";
import { useCookies } from 'react-cookie';
import { Table } from "react-bootstrap";
import RunningCheck from "../../assets/runningCheck.png";

const AllEvents = () => {
    const [cookies, setCookie] = useCookies();
    const [data, setData] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [filteredBanks, setFilteredBanks] = useState([]);
    const [filteredDevices, setFilteredDevices] = useState([]);
    const [fromDateTime, setFromDateTime] = useState('');
    const [toDateTime, setToDateTime] = useState('');

    const token = cookies.token;

    useEffect(() => {
        const headers = new Headers({
            'Valid-token': token,
        });

        // Call API and store the data array
        fetch('https://services.solucore.com/solutrak/api/buildings/getDeviceInfos', { "method": "GET", headers })
            .then((response) => response.json())
            .then((result) => {
                const allEvents = result.Data.map(device => device.deviceEvents).flat();
                setData(result.Data);
                setFilteredEvents(allEvents); // Set all events initially
            })
            .catch((error) => {
                console.error('API Error:', error);
            });
    }, [token]);

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        const dateString = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
        const timeString = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });
        return `${dateString} ${timeString}`;
    };

    const allBuildings = [...new Set(data.map(device => device.buildingName))];

    const handleBuildingSelect = (e) => {
        const selectedBuilding = e.target.value;
        if (selectedBuilding === "0") {
            // Reset to all events and clear filters
            setFilteredEvents(data.map(device => device.deviceEvents).flat());
            setFilteredBanks([]);
            setFilteredDevices([]);
        } else {
            const filteredDevicesForBuilding = data.filter(device => device.buildingName === selectedBuilding);
            const filteredEventsForBuilding = filteredDevicesForBuilding.map(device => device.deviceEvents).flat();
            setFilteredEvents(filteredEventsForBuilding);

            const filteredBankNames = [...new Set(filteredDevicesForBuilding.map(device => device.bankName))];
            setFilteredBanks(filteredBankNames);

            // filtered device type for building
            const filteredDeviceTypesForBuilding = data.filter(device => device.buildingName === selectedBuilding);
            const deviceTypes = [...new Set(filteredDeviceTypesForBuilding.map(device => device.deviceType + "-" + device.deviceName))];
            setFilteredDevices(deviceTypes);
        }
    };

    // To be implemented if we have different banks for different buildings
    const handleBankSelect = (e) => {
        const selectedBank = e.target.value;
        console.log("Selected Bank: ", selectedBank);

    };

    const handleDeviceTypeSelect = (e) => {
        const selectedDeviceType = e.target.value;
        if (selectedDeviceType !== "0") {
            const filteredDevicesForBuilding = data.filter(device => device.deviceName === selectedDeviceType.split("-")[1]);
            const filteredEventsForBuilding = filteredDevicesForBuilding.map(device => device.deviceEvents).flat();
            setFilteredEvents(filteredEventsForBuilding);
        }
    }

    function handleFromDateTimeChange(e) {
        setFromDateTime(e.target.value);
    }
    function handleToDateTimeChange(e) {
        setToDateTime(e.target.value);
        if (fromDateTime && e.target.value) {
            const fromDate = new Date(fromDateTime);
            const toDate = new Date(e.target.value);

            const filteredEventsforDate = data
                .map(device => device.deviceEvents)
                .flat()
                .filter(event => {
                    const eventDate = new Date(event.date); // Assuming event.date is a valid timestamp
                    return eventDate >= fromDate && eventDate <= toDate;
                });

            setFilteredEvents(filteredEventsforDate);
            console.log("Filtered Events by Date: ", filteredEventsforDate);
        }
    }

    return (
        <div className="allevents-container">
            <div className="dateTimePicker-allevents">
                <input
                    className="dateTime1"
                    type="datetime-local"
                    value={fromDateTime}
                    onChange={handleFromDateTimeChange}
                />
                <label className="labelTo">to</label>
                <input
                    className="dateTime2"
                    type="datetime-local"
                    value={toDateTime}
                    onChange={handleToDateTimeChange}
                />
            </div>

            <div className='event-filter-container'>
                <label className='selectLabel' htmlFor="selectBuilding">Building:
                    <select id="selectBuilding" onChange={handleBuildingSelect}>
                        <option value="0" selected> </option>
                        {allBuildings.map((buildingName, index) => (
                            <option key={index} value={buildingName}>{buildingName}</option>
                        ))}
                    </select>
                </label>

                <label className='selectLabel' htmlFor="selectBank">Bank Id and Location:
                    <select id="selectBank" onChange={handleBankSelect} disabled={filteredBanks.length === 0}>
                        <option value="0" selected> </option>
                        {filteredBanks.map((bankName, index) => (
                            <option key={index} value={bankName}>{bankName}</option>
                        ))}
                    </select>
                </label>

                <label className='selectLabel' htmlFor="selectDevice">Device Id:
                    <select id="selectDevice" onChange={handleDeviceTypeSelect} disabled={filteredDevices.length === 0}>
                        <option value="0" selected> </option>
                        {filteredDevices.map((deviceId, index) => (
                            <option key={index} value={deviceId}>{deviceId}</option>
                        ))}
                    </select>
                </label>
            </div>

            <div className="emergency-event-container">
                <Table className="emergency-event-table">
                    <thead>
                        <tr className='table-card-record'>
                            <td className='text-start ps-4' colSpan="5">
                                <h4 className='ps-5 fw-bold'>ALL EMERGENCY EVENTS</h4>
                            </td>
                        </tr>
                        <tr>
                            <th className="text-start text-white-50 fs-5 ps-5">ID</th>
                            <th className="text-start text-white-50 fs-5 ps-5">Event/Description</th>
                            <th className="text-start text-white-50 fs-5 ps-5">Date</th>
                            <th className="text-start text-white-50 fs-5 ps-5">Code</th>
                            <th className="text-start text-white-50 fs-5 ps-5">Username</th>
                        </tr>
                    </thead>
                    {console.log(filteredEvents)
                    }
                    <tbody className='scrollable-tbody'>
                        {filteredEvents && filteredEvents.length > 0 ? (
                            filteredEvents.map((event) => (
                                <tr key={event.id}>
                                    <td className="text-white ps-5">{event.id}</td>
                                    <td className="text-white ps-5">{event.description}</td>
                                    <td className="text-white ps-5">{formatTimestamp(event.date)}</td>
                                    <td className="text-white ps-5">{event.code}</td>
                                    <td className="text-white ps-5"></td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center text-white ps-5">No events to display</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <div className="other-event-container">
                <Table className="other-event-table">
                    <thead>
                        <tr className='table-card-record'>
                            <td className='text-start ps-4' colSpan="5">
                                <h4 className='ps-5 fw-bold'>ALL OTHER EVENTS</h4>
                            </td>
                        </tr>
                        <tr>
                            <th className="text-start text-white-50 fs-5 ps-5"></th>
                            <th className="text-start text-white-50 fs-5 ps-5">Event/Description</th>
                            <th className="text-start text-white-50 fs-5 ps-5">Date</th>
                            <th className="text-start text-white-50 fs-5 ps-5">Code</th>
                            <th className="text-start text-white-50 fs-5 ps-5"></th>
                        </tr>
                    </thead>
                    <tbody className='scrollable-tbody'>
                        {filteredEvents && filteredEvents.length > 0 ? (
                            filteredEvents.map((event) => (
                                <tr key={event.id}>
                                    <td className="text-white ps-5">
                                        <img src={RunningCheck} alt='running-check' className="runningCheck-image" />
                                    </td>
                                    <td className="text-white ps-5">{event.description}</td>
                                    <td className="text-white ps-5">{formatTimestamp(event.date)}</td>
                                    <td className="text-white ps-5">{event.code}</td>
                                    <td className="text-white ps-5"><span>View</span></td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center text-white ps-5">No events to display</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}

export default AllEvents;
